import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class UserSideMenu extends Component {
    render() {
        const { history, wording, basenameURL } = this.props;
        return (
            <>
                <div className='widget categories'>
                    <h3 className='widget-title heading relative heading-small uppercase bottom-line style-2 left-align'>
                        {wording.usermenu.myAccount}
                    </h3>
                    <ul className='list-dividers'>
                        <li>
                            <a className='pointer' onClick={() => history.push(`${basenameURL}/user/address`)}>
                                {wording.usermenu.address.myAddress}
                            </a>
                        </li>
                        <li>
                            <a className='pointer' onClick={() => history.push(`${basenameURL}/user/purchase`)}>
                                {wording.usermenu.purchase.myPurchase}
                            </a>
                        </li>
                        <li>
                            <a className='pointer' onClick={() => history.push(`${basenameURL}/user/return`)}>
                                {wording.usermenu.return.myReturn}
                            </a>
                        </li>
                        <li>
                            <a className='pointer' onClick={() => history.push(`${basenameURL}/user/voucher`)}>
                                {wording.usermenu.voucher.myVoucher}
                            </a>
                        </li>
                    </ul>
                </div>
            </>
        );
    }
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording,
    basenameURL: language.basenameURL
});

export default withRouter(connect(mapStateToProps)(UserSideMenu));
